import React from 'react'

export const FLAG_ROUND_ICON_SIZE_PX = 18

export const generateRoundFlagUrl = (countryIsoCode: string): string =>
  `https://pay.radom.com/flags/${countryIsoCode.toLowerCase()}.svg`

const flagIconStyle = (size: number): React.CSSProperties => ({
  width: size,
  height: size,
  maxHeight: size,
  maxWidth: size,
  display: 'block',
  borderRadius: '999px',
  flexShrink: 0,
  objectFit: 'cover'
})

export const generateRoundFlagIcon = (flagUrl: string): React.ReactElement => {
  return <img
    alt=''
    style={flagIconStyle(FLAG_ROUND_ICON_SIZE_PX)}
    src={flagUrl}
  />
}

export const generateRoundFlagIconFromCountryCode = (countryIsoCode: string, iconSize?: number): React.ReactElement => {
  const size = iconSize || FLAG_ROUND_ICON_SIZE_PX
  return <img
    alt=''
    style={flagIconStyle(size)}
    src={generateRoundFlagUrl(countryIsoCode)}
  />
}
